import { ServiceClient } from 'src/utils'
import type { Bloqueio, Suspeito } from './Bloqueios.scopes'

const serviceClient = ServiceClient.singleton()

const BASE_URL = '/api/bloqueios'

export class BloqueiosService {
    static #INSTANCE = new BloqueiosService()
    static readonly singleton = () => BloqueiosService.#INSTANCE

    async listar(
        somenteAtivos: boolean,
        busca: string,
        offset: number,
        limit: number
    ): Promise<{ total: number; itens: Bloqueio[] }> {
        const params = new URLSearchParams({ ativos: `${somenteAtivos}`, offset: `${offset}`, limit: `${limit}` })
        if (busca) params.set('q', busca)
        return serviceClient.authGet(`${BASE_URL}?${params.toString()}`)
    }

    async suspeitos(): Promise<Suspeito[]> {
        return serviceClient.authGet<Suspeito[]>(`${BASE_URL}/suspeitos`)
    }

    async bloquear(telefone: string, motivo: string): Promise<Bloqueio> {
        return serviceClient.authPost<Bloqueio>(BASE_URL, { telefone, motivo })
    }

    async tentarNaMeta(telefone: string): Promise<Bloqueio> {
        return serviceClient.authPost<Bloqueio>(`${BASE_URL}/${telefone}/meta`, {})
    }

    async desbloquear(telefone: string, motivo: string): Promise<Bloqueio> {
        return serviceClient.authPost<Bloqueio>(`${BASE_URL}/${telefone}/desbloquear`, { motivo })
    }
}

export default BloqueiosService.singleton()
